import type { Lead } from '../../../lib/api'
import { SectionBody, SectionHeader } from './StageContextLayout'

export function ActivationContext(_props: { lead: Lead }) {
  return (
    <>
      <SectionHeader color="#ccfbf1">
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#0f766e' }}>Activation</h3>
      </SectionHeader>
      <SectionBody>
        <p style={{ fontSize: '14px', color: '#0f766e', marginBottom: '8px' }}>
          All deployment tasks are complete. The merchant is ready to process their first transaction.
        </p>
        <p style={{ fontSize: '13px', color: '#6b7280' }}>
          The system will automatically transition to Live once the first batch is detected via Fiserv transaction sync.
        </p>
      </SectionBody>
    </>
  )
}
